namespace Areas.Account.YearMonthChart {
    "use strict";

    //below need research ... thought is to start chart with recent YearMonth

    export function ymChartInitialized(e) {
          e.component.zoomArgument("2019-01","2020-03")
    }

    export function ymZoomStart(e) {
        var a = 1;
    }

    export function ymCustomizeLabels() {
        return { visible: false };
    }

    export function ymZoomEnd(e) {
        var b = 1;
    }

}